<dialog
  #paymentDialog
  class="subscription-payment-dialog"
  aria-labelledby="subscription-payment-title"
  (cancel)="onDialogCancel($event)">
  <div class="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl dark:bg-[#0e1726]">
    <h2 id="subscription-payment-title" class="text-xl font-bold text-primary">
      {{ title() }}
    </h2>
    @if (description()) {
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">{{ description() }}</p>
    }

    <div class="mt-5 space-y-4">
      <div class="rounded-xl border border-gray-200 bg-gray-50 p-4 dark:border-white/10 dark:bg-white/5">
        <div class="flex items-center justify-between gap-3 text-sm">
          <span class="text-gray-600 dark:text-gray-300">Plan amount (excl. GST)</span>
          <span class="font-medium text-gray-900 dark:text-white">
            {{ baseAmount() | currency: 'INR' : 'symbol' : '1.2-2' }}
          </span>
        </div>
        <div class="mt-2 flex items-center justify-between gap-3 text-sm">
          <span class="text-gray-600 dark:text-gray-300">GST ({{ gstRate() }}%)</span>
          <span class="font-medium text-gray-900 dark:text-white">
            {{ gstAmount() | currency: 'INR' : 'symbol' : '1.2-2' }}
          </span>
        </div>
      </div>

      <div>
        <label
          class="mb-1 block text-xs font-semibold uppercase tracking-wide text-gray-500"
          for="subscription-payment-amount">
          Amount to pay
        </label>
        <input
          id="subscription-payment-amount"
          type="text"
          class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-lg font-bold text-gray-900 dark:border-white/10 dark:bg-white/5 dark:text-white"
          readonly
          [value]="amount() | currency: 'INR' : 'symbol' : '1.2-2'" />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Inclusive of GST
        </p>
      </div>
      @if (billingLabel()) {
        <div>
          <label
            class="mb-1 block text-xs font-semibold uppercase tracking-wide text-gray-500"
            for="subscription-payment-cycle">
            Billing cycle
          </label>
          <input
            id="subscription-payment-cycle"
            type="text"
            class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-900 dark:border-white/10 dark:bg-white/5 dark:text-white"
            readonly
            [value]="billingLabel()" />
        </div>
      }
    </div>

    <p class="mt-4 text-xs text-gray-500">
      You will be redirected to Razorpay to complete the payment securely.
    </p>

    <div class="mt-6 flex gap-3">
      <button
        type="button"
        class="btn flex-1 rounded-full border border-gray-300 bg-white text-gray-700 dark:border-white/20 dark:bg-transparent dark:text-gray-200"
        [disabled]="processing()"
        (click)="cancel.emit()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary flex-1 rounded-full"
        [disabled]="processing()"
        (click)="proceed.emit()">
        {{ processing() ? 'Processing…' : 'Proceed to Pay' }}
      </button>
    </div>
  </div>
</dialog>
